<script setup lang="ts">
import { Image } from 'vant';
import type { Project } from '@/api';
import { useRoute, useRouter } from 'vue-router';
import { useParamStore } from '@/store/param.ts';

const props = defineProps<{ projects: Project[] }>();

const router = useRouter();
const route = useRoute();
const { refreshLoadResourceByRoute } = useParamStore();

const onClick = async (project: Project) => {
  if (project.type === 'style3d') {
    await router.replace({
      params: { ...route.params },
      query: {
        ...route.query,
        sco: btoa(project.scoPath),
        scoId: project.scoId,
        originScoUrl: btoa(project.originUrl || '')
      }
    });
  } else {
    await router.replace({
      params: { ...route.params },
      query: { ...route.query, scoId: project.scoId, sco: undefined, originScoUrl: btoa(project.originUrl || '') }
    });
  }
  await refreshLoadResourceByRoute();
};
</script>

<template>
  <div
    v-for="(item) in props.projects"
    :key="item.id"
  >
    <Image
      width="75"
      height="75"
      :src="item.thumb"
      fit="scale-down"
      @click="()=>onClick(item)"
    />
    <div class="project-name">
      {{ item.name ? item.name : '' }}
    </div>
  </div>
</template>

<style scoped>
.project-name {
  color: rgba(255, 255, 255, 0.92);
  font-size: 12px;
  text-align: center;
  margin-top: 6px;
  line-height: 1.2;
  max-height: 3.6em; /* allow up to 3 lines */
  width: 85px; /* match image width */
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-word;
  text-overflow: ellipsis;
  white-space: normal;
}
</style>
